import React, { useState } from "react";
import styled, { css } from "styled-components";

const InputContainer = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	border: none;
`;

const Label = styled.label`
	position: absolute;
	top: 50%;
	left: 20px;
	transform: translateY(-50%);
	pointer-events: none;
	transition: 0.2s ease all;
	color: #a0a3bd;
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.3px;
	${({ isFocused, hasValue }) =>
		(isFocused || hasValue) &&
		css`
			top: 5px;
			color: #a0a3bd;
			font-size: 10px;
			font-weight: 400;
			line-height: 12px;
			letter-spacing: 0.25px;
		`}
`;

const StakeInput = styled.input`
	display: flex;
	height: 40px;
	padding: 0 20px;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	width: 100%;
	border-radius: 50px;
	background: var(--modal-input-bg);
	border: none;
	outline: none;
	padding-top: 10px;
	color: #f7f7fc;
	font-size: 12px;
	font-weight: 400;
	line-height: 16px;
	letter-spacing: 0.3px;

	&:focus {
		border: 1px solid var(--main-explosive);
		background: var(--input-bg-has-value);
	}

	&:focus + ${Label}, &:not(:placeholder-shown) + ${Label} {
		top: 10px;
		border: none;
		outline: none;
		color: #a0a3bd;
		font-size: 10px;
		font-weight: 400;
		line-height: 12px;
		letter-spacing: 0.25px;
	}
`;

const FloatingLabelButton = ({ onChange, label, onClick, value }) => {
	const [isFocused, setIsFocused] = useState(false);

	const handleFocus = () => setIsFocused(true);
	const handleBlur = () => setIsFocused(false);

	return (
		<InputContainer>
			<StakeInput
				onWheel={(e) => e.target.blur()}
				type="text"
				value={value}
				onFocus={handleFocus}
				onBlur={handleBlur}
				onClick={onClick}
				placeholder=" "
				readOnly
			/>
			<Label
				isFocused={isFocused}
				hasValue={!!value}>
				{label}
			</Label>
		</InputContainer>
	);
};

export default FloatingLabelButton;
